<template>
    <div class="min-obraz-form">
        <div class="header-title" v-html="$t('minEducationForms')"/>

            <v-simple-table class="if-tab">
                <template v-slot:default>
            <thead>
            <tr>
                <th>{{$t('formName')}}</th>
                <th>Скачать</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="form in formLinks" :key="form.path">
                <td style="text-align: start!important;">{{form.title}}</td>
                <td>
                    <v-btn variant="outlined" size="large"
                           icon color="primary" @click="downloadFile(form.path)">
                        <v-icon color="primary">mdi mdi-download-outline</v-icon>
                    </v-btn>
                </td>
            </tr>
            </tbody>
                </template>
            </v-simple-table>
    </div>
</template>

<script>
export default {
  data () {
    return {
      formLinks: [
        { title: 'Календарно-тематический план', path: '/docs/forms/form1.docx' },
        { title: 'План-конспект урока', path: '/docs/forms/form2.docx' },
        { title: 'Отчет о качестве знаний и успеваемости учащихся по преподаваемому предмету', path: '/docs/forms/form3.docx' },
        { title: 'Документация по соблюдению техники безопасности на уроке ', path: '/docs/forms/form4.docx' },
        { title: 'Информация об участниках государственной итоговой аттестации, общереспубликанского тестирования', path: '/docs/forms/form5.docx' },
        { title: 'Отчет о движении, успеваемости и посещаемости учащихся класса', path: '/docs/forms/form6.docx' },
        { title: 'Характеристика на ученика', path: '/docs/forms/form7.docx' },
        { title: 'Отчет по воспитательной работе', path: '/docs/forms/form8.docx' },
        { title: 'Социальный паспорт класса', path: '/docs/forms/form9.docx' },
        { title: 'План работы социального педагога', path: '/docs/forms/form10.docx' },
        { title: 'Отчет по реализации плана работы', path: '/docs/forms/form11.docx' },
        { title: 'Отчет по профилактике безнадзорности учащихся', path: '/docs/forms/form12.docx' },
        { title: 'Социальный банк данных', path: '/docs/forms/form13.docx' },
        { title: 'План работы по внеклассной и внешкольной воспитательной работе', path: '/docs/forms/form14.docx' },
        { title: 'Отчет о проделанной работе', path: '/docs/forms/form15.docx' },
        { title: 'Протоколы заседаний классных руководителей', path: '/docs/forms/form16.docx' },
        { title: 'Журнал организатора внеклассной и внешкольной работы', path: '/docs/forms/form17.docx' }
      ]
    }
  },
    methods: {
        downloadFile (url) {
            window.location = `${url}`
        }
    }
}
</script>

<style lang="scss" scoped>
th{
    font-size: 16px!important;
    font-weight: bold;
}
.header-title {
    margin-bottom: 15px;
    font-size: 28px;
    font-weight: bold;
}
.min-obraz-form {
    padding: 30px;
    .table {
        a {
            color: #fff;
            text-decoration: none;
        }
        th, td{
            vertical-align: middle;
        }
    }
}
th, td{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}
.if-tab{
    width: max-content;
}

@media screen and (max-width: 768px){
    .min-obraz-form {
        padding: 10px;
    }
    .if-tab{
        width: 100%;
    }
}
</style>
